/**
 * @summary Enum which represents the Vuex modules available.
 */
export enum StoreModules {
	Setup = "setup",
}
